// @ngInject
Models.BrochureProposalsCollection = function BrochureProposalsCollection(BaseCollection) {

    return Class(BaseCollection, {
            constructor: function constructor() {
                this.constructor.$super.call(this);
                this._collection.__className = 'BrochureProposalsCollection';
                this._collection.__childsType = 'ProposalModel';
                this._collection.shouldMergeOnLoad = true;
                return this._collection;
            }
        }
    );
};